import React, { useRef, useEffect, useState } from "react";
import "./offer.css";
import { useLocation } from "react-router-dom";

const Offers = ({ offers }) => {
  const sectionRef = useRef(null);
  const [widths, setWidths] = useState(new Array(offers.length).fill("95vw"));
  const location = useLocation(); // Get current location

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const section = sectionRef.current;
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top <= windowHeight / 2 && rect.bottom >= windowHeight / 2) {
        const scrollProgress = (windowHeight / 2 - rect.top) / rect.height;
        setWidths((prevWidths) =>
          prevWidths.map((_, index) => {
            const progress = Math.max(
              0,
              Math.min(1, scrollProgress * 3 - index)
            );
            const calculatedWidth = 95 - progress * 65; // Shrinking from 95vw to 30vw
            return `${calculatedWidth}vw`;
          })
        );
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="offer" ref={sectionRef}>
      <div className="offerSlide">
        {offers.map((offer, index) => (
          <div
            key={index}
            className="oSlides"
            style={{
              width: widths[index], // Corrected here. No need for `${widths[index]}px`
              backgroundColor:
                parseFloat(widths[index]) < 50 ? "#f47024" : "#ffece1",
              transition:
                "width 1s ease-in-out, background-color 0.5s ease-in-out",
            }}
          >
            <div className="bennar-bottom-section text-start p-3 row align-items-between h-100">
              <div>
                <p
                  className="fs-3 fw-semibold "
                  style={{
                    color: parseFloat(widths[index]) < 50 ? "#fff" : "#f47024",
                  }}
                >
                  {offer.title}
                </p>
              </div>
              <div>
                {offer.points && offer.points.map((point, pointIndex) => (
                  <p
                    key={pointIndex}
                    className="fs-5 mt-4"
                    style={{
                      color: parseFloat(widths[index]) < 50 ? "#fff" : "#f47024",
                    }}
                  >
                    {point}
                  </p>
                ))}
              </div>

              {location.pathname === "/our-product" && ( // Only show if path is /our-product
                <div>
                  <a
                    href={offer.link}
                    className="buttonEffect mb-2 text-decoration-none"
                  >
                    Move to page
                  </a>
                </div>
              )}
              {offer.buttonName && (
                <div className="mt-5">
                  <a
                    href={offer.link}
                    className="buttonEffect mb-2 text-decoration-none"
                  >
                    {offer.buttonName}
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Offers;
